import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { useParams } from "react-router";
import { useApi } from "~hooks/apiHooks/useApi";
import type { FixturePersonUpsert } from "../types";

export const useUpdateFixturePerson = (options: UseMutationOptions<unknown, unknown, FixturePersonUpsert> = {}) => {
  const request = useApi();
  const { sport, organizationId, fixtureId } = useParams();

  if (!sport || !organizationId || !fixtureId) {
    console.error({ sport, organizationId, fixtureId });
    throw new Error("Missing required params");
  }

  return useMutation<unknown, unknown, FixturePersonUpsert, unknown>({
    mutationFn: (body: FixturePersonUpsert) =>
      request(`${sport}/o/${organizationId}/fixtures/${fixtureId}/persons`, {
        body,
        method: "POST",
      }),
    ...options,
  });
};
